module.exports = __webpack_public_path__ + "static/media/29EUNOG7.6a2e80ec.jpg";